import { render, staticRenderFns } from "./EventTypesSelect.vue?vue&type=template&id=64da09b0&scoped=true"
import script from "./EventTypesSelect.vue?vue&type=script&lang=js"
export * from "./EventTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da09b0",
  null
  
)

export default component.exports